import React from 'react';
import PropTypes from 'prop-types';

import { LEGAL, LEGAL_REVIEW } from 'config/formSections/legal';

import connectSubsection from 'components/Section/shared/SubsectionConnector';

import { isPVQForm } from 'helpers/form';
import ConnectedOffenses from '../Police/Offenses';
import ConnectedOtherOffenses from '../Police/OtherOffenses';
import ConnectedDomesticViolenceList from '../Police/DomesticViolenceList';
import {
  History, Revoked, Debarred, ClearanceIssues, PivIssues, ForeignInvestigations
} from '../Investigations';
import ConnectedNonCriminalCourtActions from '../NonCriminalCourtActions';
import {
  Unauthorized, Manipulating, Unlawful, Denied, NonCompliance, ProtectedUnauthorized
} from '../Technology';
import CriminalConvictions from '../CriminalConvictions';

import {
  TerroristOrganization,
  MembershipOverthrow,
  MembershipViolence,
  EngagedInTerrorism,
  Advocating,
  ActivitiesToOverthrow,
  TerrorismAssociation,
  TerroristOrganizationMembership, // PVQ
  TerrorismEngagement, // PVQ
  TerrorismAdvocacy, // PVQ
  RightsSuppressionGroup, // PVQ
  ViolentRightsSuppressionGroup, // PVQ
  ViolentOrganization, // PVQ
  ViolentActs, // PVQ
  HateCrimeAdvocacy, // PVQ
  InternationalAndDomesticTerrorism, // PVQ
  InternationalAndDomesticTerrorismEngagement, // PVQ
  InternationalAndDomesticTerrorismAssociation, // PVQ
  InternationalAndDomesticTerrorismAdvocacy, // PVQ
} from '../Associations';

const sectionConfig = {
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_REVIEW.name,
};

export const Review = function ({
  requireLegalOtherOffensesSection,
  requireLegalNonCriminalCourtSection,
  requireLegalTechnologySection,
  formType
}) {
  const props = {
    required: true,
    scrollIntoView: false,
  };

  const sectionDivider = <hr className="section-divider" />;
  const isPVQ = isPVQForm(formType);
  return isPVQ ? (
    <div>
      <ConnectedOffenses {...props} />
      {sectionDivider}
      <ConnectedOtherOffenses {...props} />
      {sectionDivider}
      <ConnectedDomesticViolenceList {...props} />
      {sectionDivider}
      <History {...props} />
      {sectionDivider}
      <ClearanceIssues {...props} />
      {sectionDivider}
      <PivIssues {...props} />
      {sectionDivider}
      <Debarred {...props} />
      {sectionDivider}
      <ForeignInvestigations {...props} />

      {formType.includes('B') && (
        <span>
          {sectionDivider}
          <ConnectedNonCriminalCourtActions {...props} />
        </span>
      )}

      <span>
        {sectionDivider}
        <Unauthorized {...props} />
        {sectionDivider}
        <Manipulating {...props} />
        {sectionDivider}
        <Denied {...props} />
        {sectionDivider}
        <Unlawful {...props} />
      </span>

      <span>
        {sectionDivider}
        <ProtectedUnauthorized {...props} />
        {sectionDivider}
        <NonCompliance {...props} />
      </span>

      {sectionDivider}
      <TerroristOrganizationMembership {...props} />
      {sectionDivider}
      <TerrorismEngagement {...props} />
      {sectionDivider}
      <TerrorismAdvocacy {...props} />
      {sectionDivider}
      <RightsSuppressionGroup {...props} />
      {sectionDivider}
      <ViolentRightsSuppressionGroup {...props} />
      {sectionDivider}
      <ViolentOrganization {...props} />
      {sectionDivider}
      <ViolentActs {...props} />
      {sectionDivider}
      <HateCrimeAdvocacy {...props} />
      {sectionDivider}
      <InternationalAndDomesticTerrorism {...props} />
      {sectionDivider}
      <InternationalAndDomesticTerrorismEngagement {...props} />
      {sectionDivider}
      <InternationalAndDomesticTerrorismAssociation {...props} />
      {sectionDivider}
      <InternationalAndDomesticTerrorismAdvocacy {...props} />

      {formType.includes('C') && (
        <span>
          {sectionDivider}
          <CriminalConvictions {...props} />
        </span>
      )}
    </div>

  ) : (
    <div>
      <ConnectedOffenses {...props} />

      {requireLegalOtherOffensesSection && (
        <span>
          {sectionDivider}
          <ConnectedOtherOffenses {...props} />
        </span>
      )}

      {sectionDivider}
      <ConnectedDomesticViolenceList {...props} />

      {sectionDivider}
      <History {...props} />
      {sectionDivider}
      <Revoked {...props} />
      {sectionDivider}
      <Debarred {...props} />

      {requireLegalNonCriminalCourtSection && (
        <span>
          {sectionDivider}
          <ConnectedNonCriminalCourtActions {...props} />
        </span>
      )}

      {requireLegalTechnologySection && (
        <span>
          {sectionDivider}
          <Unauthorized {...props} />
          {sectionDivider}
          <Manipulating {...props} />
          {sectionDivider}
          <Unlawful {...props} />
        </span>
      )}

      {sectionDivider}
      <TerroristOrganization {...props} />
      {sectionDivider}
      <EngagedInTerrorism {...props} />
      {sectionDivider}
      <Advocating {...props} />
      {sectionDivider}
      <MembershipOverthrow {...props} />
      {sectionDivider}
      <MembershipViolence {...props} />
      {sectionDivider}
      <ActivitiesToOverthrow {...props} />
      {sectionDivider}
      <TerrorismAssociation {...props} />
    </div>
  );
};

Review.propTypes = {
  requireLegalOtherOffensesSection: PropTypes.bool,
  requireLegalNonCriminalCourtSection: PropTypes.bool,
  requireLegalTechnologySection: PropTypes.bool,
};

Review.defaultProps = {
  requireLegalOtherOffensesSection: true,
  requireLegalNonCriminalCourtSection: true,
  requireLegalTechnologySection: true,
};

export default connectSubsection(Review, sectionConfig);
